/** Textes « entretien » — le français fait foi. */
export const entretien = {
  erreur: 'Erreur',
  titre: 'Entretien',
  resume: (n: number, total: string) => `${n} intervention(s) · ${total} dépenses`,
  surTotal: (n: number) => ` · sur ${n} au total`,
  voirInterventions: 'Voir les interventions',
  voirBilan: 'Voir le bilan',
  enregistrer: 'Enregistrer un entretien',
  depense: 'Dépensé en entretien',
  joursImmo: "Jours d'immobilisation",
  manque: 'Manque à gagner',
  manqueAide: 'ces jours-là, la voiture ne pouvait pas être louée',
  coutReel: 'Coût réel',
  coutReelAide: 'facture + immobilisation',
  parVoiture: 'Par voiture',
  colBilan: {
    vehicule: 'Véhicule', interventions: 'Interventions', depense: 'Dépensé', jours: 'Jours immobilisée',
    manque: 'Manque à gagner', prochaine: 'Prochaine échéance',
  },
  coutPar: (u: string) => `Coût / 1 000 ${u}`,
  noteBilan: (u: string) => `Le manque à gagner est calculé au tarif de la voiture : une voiture au garage ne loue pas. Le coût par 1 000 ${u} permet de comparer des voitures qui ne roulent pas autant.`,
  alerte: (ech: string, compteur: string, reste: string, u: string) =>
    `Prochaine échéance à ${ech} ${u}, le compteur affiche ${compteur} ${u} — il reste ${reste} ${u}.`,
  toutesVoitures: 'Toutes les voitures',
  tousMois: 'Tous les mois',
  toutVoir: 'Tout voir',
  interventions: 'Interventions',
  aucun: 'Aucun entretien enregistré',
  aucunFiltre: 'Aucune intervention pour ce filtre',
  col: { date: 'Date', vehicule: 'Véhicule', intervention: 'Intervention', prestataire: 'Prestataire', km: 'Km', cout: 'Coût', immo: 'Immobilisation', prochaine: 'Prochaine échéance' },
  noteImmo: 'Une immobilisation renseignée bloque automatiquement le véhicule dans le planning et dans les disponibilités.',
  vehicule: 'Véhicule',
  choisir: 'Choisir…',
  intervention: 'Intervention',
  types: {
    Vidange: 'Vidange', Pneus: 'Pneus', Plaquettes: 'Plaquettes', 'Révision': 'Révision',
    Panne: 'Panne', Carrosserie: 'Carrosserie', Autre: 'Autre',
  } as Record<string, string>,
  date: 'Date',
  kilometrage: 'Kilométrage',
  cout: (d: string) => `Coût (${d})`,
  prestataire: 'Prestataire',
  payeCaisse: 'Payé avec la caisse des dépenses',
  payeCaisseAide: "Le montant sort du tiroir des dépenses. Décochez si quelqu'un a payé de sa poche.",
  immoDu: 'Immobilisé du',
  immoAu: 'au',
  prochaineKm: (u: string) => `Prochaine échéance (${u})`,
  prochaineKmAide: (u: string) => `Le logiciel vous alertera 2 000 ${u} avant.`,
  description: 'Description',
  annuler: 'Annuler',
  valider: 'Enregistrer',
};
